import { ApolloClient, InMemoryCache, ApolloLink } from "@apollo/client";
import { BatchHttpLink } from "@apollo/client/link/batch-http";

const cleanTypeName = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    const omitTypename = (key: string, value: unknown) =>
      key === "__typename" ? undefined : value;
    operation.variables = JSON.parse(
      JSON.stringify(operation.variables),
      omitTypename
    );
  }
  return forward(operation).map((data) => {
    return data;
  });
});

const httpLink = new BatchHttpLink({
  credentials: "include",
  // TODO if running cms_gql_server locally, enable the following line and comment out the other uri.
  //uri: `http://localhost:8081/content/federatedCms/v1/graphql`,
  uri: `https://content-test.services.nike.com/content/federatedCms/v1/graphql`,
  batchMax: 20, // No more than 20 operations per batch
  batchInterval: 200, // Wait no more than 200ms after first batched operation
});


const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      ecscluster: {
        keyFields: [
          "name",
          "version",
          "currentTask",
          "latestTask",
          "lastDeployed",
          "desiredCount",
          "pendingCount",
          "runningCount",
        ],
      },
    },
  }),
  link: ApolloLink.from([cleanTypeName, httpLink]),
});

export default client;
